interface SortableHeaderProps {
  label: string;
  keyName: string;
  currentSort: { key: string; direction: 'asc' | 'desc' };
  onSort: (key: string) => void;
}

const SortableHeader: React.FC<SortableHeaderProps> = ({
  label,
  keyName,
  currentSort,
  onSort
}) => {
  return (
    <span onClick={() => onSort(keyName)}>
      {label}
      {currentSort.key === keyName ? (
        <span style={{ marginLeft: '5px' }}>
          {currentSort.direction === 'asc' ? '↑' : '↓'}
        </span>
      ) : (
        <span style={{ marginLeft: '5px' }}>↕</span>
      )}
    </span>
  );
};

export default SortableHeader;
